// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"555":"ComponentFeedResources","869":"styles"}[chunkId] || chunkId) + ".css";
};